import axios from "axios"

export default (initalCurrentPage = 1, initialTotalPages = 1, initialLoadMore = true, initialElementId = null, initialJsVars = {}) => ({

    currentPage: initalCurrentPage,
    totalPages: initialTotalPages,
    loadMore: initialLoadMore,
    elementId: initialElementId,
    jsVars: initialJsVars,
    commentsInstance: null,

    init(){

        this.commentsInstance = new Comments.Instance(this.elementId, this.jsVars.settings);

        this.checkLoadMore();
    },

	load(){

        const self = this;

        if(self.inLimit()){

            self.currentPage++;

            axios.get(window.location.origin + window.location.pathname + '/p' + self.currentPage).then(function (response) {
                self.$refs.comments.insertAdjacentHTML('beforeend', response.data);
                self.checkLoadMore();
                self.reInitComments();
            });

        }

    },

    reInitComments(){

        let allComments = this.$refs.comments.querySelectorAll('[data-role="comment"]');

        allComments.forEach((element) => {
            new Comments.Comment(this.commentsInstance, element);
        })
    },

    checkLoadMore(){
        this.loadMore = this.inLimit()
    },

    inLimit(){
        return (this.currentPage < this.totalPages)
    }

})
